import Helper from './Helper';

class HeroVideo {
  constructor(config = {}) {
    const {
      heroSelector,
      heroObject,
      tabObject,
      mobileImgSelector,
      videoSelector,
      removeImages
    } = config;
    if ( typeof heroObject !== "undefined" ) {
      this.heroObject = heroObject;
      this.heroSectionsArray = [this.heroObject];
    } else {
      this.heroSections = document.querySelectorAll(heroSelector);
      this.heroSectionsArray = Array.prototype.slice.call(this.heroSections);
    }
    this.tabObject = tabObject;
    this.mobileImgSelector = mobileImgSelector || '.ns-hero-section__mobile-img';
    this.videoSelector = videoSelector || '.ns-hero-section__video';
    this.removeImages = removeImages || false;
    this.breakpointMd = 1025;
    this.videoContainerClass = "ns-hero-section__background-video";
    this.imageContainerClass = "ns-hero-section__background-img";
    this.body = document.querySelector('body');
    if(this.heroSections || this.heroObject){
      this.bindEvents();
    }
  }


  bindEvents() {
    const vw = window.innerWidth;

    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    if(Helper.IsSafari() || vw < this.breakpointMd){
      this.body.classList.add('safari');
    }

    if (vw >= this.breakpointMd && !Helper.IsSafari()) {
      this.heroSectionsArray.forEach((hero, i) => {
        this.addVideo(hero);
        this.removeBackgroundImage(hero);
      });

    } else {
      this.heroSectionsArray.forEach((hero, i) => {
        this.removeVideo(hero);
        this.addBackgroundImage(hero);
      });
    }

    window.addEventListener('resize', () => {
      const vw = window.innerWidth;
      if (vw >= this.breakpointMd) {
        this.heroSectionsArray.forEach((hero, i) => {
          this.addVideo(hero);
          this.removeBackgroundImage(hero);
        });

      } else {
        this.heroSectionsArray.forEach((hero, i) => {
          this.removeVideo(hero);
          this.addBackgroundImage(hero);
        });
      }
    });
  }

  addBackgroundImage(hero) {
    if ( typeof this.tabObject === "undefined" ) {
      // default behaviour for hero sections
      if ( hero.querySelector(this.mobileImgSelector) && !hero.querySelector('.'+this.imageContainerClass) ) {
        let heroImage = hero.querySelector(this.mobileImgSelector).dataset.src;
        if ( !heroImage ) {
          heroImage = hero.querySelector(this.mobileImgSelector).src;
        }
        let imageContainer = document.createElement('div');
        imageContainer.classList.add(this.imageContainerClass);
        imageContainer.style.backgroundImage = "url('"+heroImage+"')";
        hero.appendChild(imageContainer);
      }
    } else {
      // add background-image to each tab
      if ( this.tabObject.querySelector(this.mobileImgSelector) ) {
        if ( this.removeImages ) {
          this.removeBackgroundImage(hero);
        }

        let heroImage = this.tabObject.querySelector(this.mobileImgSelector).dataset.src;
        if ( !heroImage ) {
          heroImage = this.tabObject.querySelector(this.mobileImgSelector).src;
        }
        let imageContainer = document.createElement('div');
        imageContainer.classList.add(this.imageContainerClass);
        imageContainer.style.backgroundImage = "url('"+heroImage+"')";
        this.tabObject.appendChild(imageContainer);
      }
    }

  }

  removeBackgroundImage(hero) {
    if ( hero.querySelector('.'+this.imageContainerClass) ) {
      let heroImages = hero.querySelectorAll('.'+this.imageContainerClass);
      heroImages.forEach((image, i) => {
        Helper.removeFromDom(image);
      });
    }
  }

  addVideo(hero) {
    // Safari 3.0+ "[object HTMLElementConstructor]"
    // check to show image instead of video in safari
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    if ( isSafari ) {

      this.addBackgroundImage(hero);
    } else {
      if ( typeof this.tabObject === "undefined" ) {
        // default behaviour for hero sections
        if ( hero.querySelector(this.videoSelector).textContent && !hero.querySelector('.'+this.videoContainerClass) ) {
          let heroVideoString = hero.querySelector(this.videoSelector).textContent;
          let videoContainer = document.createElement('video');
          videoContainer.classList.add(this.videoContainerClass);
          videoContainer.muted = true;
          videoContainer.loop = true;
          videoContainer.autoplay = true;
          videoContainer.innerHTML = '<source src="'+heroVideoString+'" type="video/webm">Video not supported';

          hero.appendChild(videoContainer);

          let heroVideo = hero.querySelector('.'+this.videoContainerClass);
          heroVideo.oncanplaythrough = function() {
            heroVideo.muted = true;
            heroVideo.play();
          };
        }
      } else {
        // overwrite for tab
        if ( this.tabObject.querySelector(this.videoSelector).textContent ) {
          this.removeVideo(hero);
          let heroVideoString = this.tabObject.querySelector(this.videoSelector).textContent;
          let videoContainer = document.createElement('video');
          videoContainer.classList.add(this.videoContainerClass);
          videoContainer.muted = true;
          videoContainer.loop = true;
          videoContainer.autoplay = true;
          videoContainer.innerHTML = '<source src="'+heroVideoString+'" type="video/webm">Video not supported';

          hero.appendChild(videoContainer);

          let heroVideo = hero.querySelector('.'+this.videoContainerClass);
          heroVideo.oncanplaythrough = function() {
            heroVideo.muted = true;
            heroVideo.play();
          };
        }
      }
    }
  }

  removeVideo(hero) {
    if ( hero.querySelector('.'+this.videoContainerClass) ) {
      let heroVideo = hero.querySelector('.'+this.videoContainerClass);
      Helper.removeFromDom(heroVideo);
    }
  }
}

export default HeroVideo;
